import { BrowserRouter, Route, Routes } from "react-router-dom";
import MainLayout from "../Layouts/MainLayout";
import { routes } from "./routes";
import Login from "Pages/authentication/Login";
import SingleJob from "Pages/Career/singleJob";
import UpdateJob from "Pages/Career/updateJob";

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<MainLayout />}>
          {routes}
          <Route path="/career/job/:id" element={<SingleJob />} />
          <Route path="/career/update-job/:id" element={<UpdateJob />} />
        </Route>
        <Route path="/login" element={<Login />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
